'use client';

import { useState, useEffect } from 'react';
import Script from 'next/script';

const HUBSPOT_PORTAL_ID = '2746635';
const PRODUCTION_HOSTS = ['identio.fi', 'www.identio.fi'];

/**
 * Loads HubSpot embed (tracking, chat, etc.) only on production domain
 * so preview/staging deployments don't send data to HubSpot.
 */
export function HubSpotScript() {
  const [loadScript, setLoadScript] = useState(false);

  useEffect(() => {
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    setLoadScript(PRODUCTION_HOSTS.some((h) => host === h));
  }, []);

  if (!loadScript) return null;

  return (
    <Script
      id="hs-script-loader"
      src={`https://js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`}
      strategy="lazyOnload"
    />
  );
}
